export default __webpack_public_path__ + "static/media/logo-fablabrec.ae346b15.svg";